export default theme => ({
  topbar: {
    with: '100%',
    position: 'fixed',
    width: '100%',
    top: 0,
    left: 0,
    right: 'auto',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  topbarShift: {
    marginLeft: '271px',
    width: 'calc(-271px + 100vw)'
  },
  topbarShiftCollapsed: {
    marginLeft: '81px',
    width: 'calc(-81px + 100vw)'
  },
  drawerPaper: {
    zIndex: 1200,
    width: '271px',
  },
  drawerPaperCollapsed: {
    zIndex: 1200,
    width: '81px',
  },
  sidebar: {
    overflow: 'auto',
    overflowX: 'hidden',
    //width: '270px',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  customScrollBar: {
        '&::-webkit-scrollbar': {
            width: '0.4em',
        },
        '&::-webkit-scrollbar-track': {
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
        },
        '&::-webkit-scrollbar-track-piece': {
            background: '#525252'
        },
        '&::-webkit-scrollbar-thumb:horizontal': {
            background: '#E5E5E5',
            },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#BBBBBB',
            outline: '1px solid slategrey'
        }
        
  },
  content: {
    //backgroundColor: theme.palette.background.default,
    backgroundColor: '#0b1738',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  contentShift: {
    marginLeft: '270px'
  },
  contentShiftCollapsed: {
    marginLeft: '80px',
    backgroundColor: 'red',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0
    },
  },
  modalIsOpen: {
    marginLeft: 0,
    width: '100%'
  }
});



